module.exports = __webpack_public_path__ + "img/TwentyBig.f04eabb3.png";